<template>
    <div class="areachart_wrapper chart_wrapper" id="ChartWrapper" data-chart="area">
        <div class="area_legend_items">
            <div class="legend_group first">
                <div class="legend_item" v-for="(item, itemKey) in legendItems">
                    <div class="item_chip" :style="{ backgroundColor: item.color}"></div>
                    <div class="item_label">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
        <div class="loader lds-ellipsis" :class="(loaderDisplayed) ? 'displayed': ''"><div></div><div></div><div></div><div></div></div>
        <div class="highcharts_container areachart_container" :id="chartID" ></div>
    </div>
</template>

<script>
    import * as UTILS from '~/commons/utils/index.js'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import axios from 'axios'
    import {_} from 'underscore'
    var numberFormat = require('underscore.string/numberFormat')

    export default {
        props: {
            chartID: {
                type: String,
                default: function () {
                    return 'AreaChart'
                }
            },
            areaChartData: {
                type: Array,
                default: function () {
                    return []
                }
            },
            areaChartCategories: {
                type: Array,
                default: function () {
                    return []
                }
            },
            indicatorUnit: {
                type: String, 
                default: function (){
                    return ""
                }
            },
            indicatorLabel: {
                type: String, 
                default: function (){
                    return ""
                }
            }
        },
        data: function () {
            return {
                areaChartHigcharts: '',
                categories: ["2017", "2018", "2019", "2020", "2021"],
                orderedSeries: [],
                legendItems: [],
                loaderDisplayed: true
            }
        },
        
        mounted () {
            var self = this;
            if(this.areaChartData.length > 0) this.renderAreaChart();
        },
        methods: {

            renderAreaChart: function () {
                var self = this;
                this.loaderDisplayed = true;

                this.legendItems = _.map(this.areaChartData, function (o){
                    return {
                        name: o.name,
                        color: o.color
                    }
                })

                this.areaChartHigcharts = new Highcharts.chart({
                    chart: {
                        type: 'area',
                        renderTo: self.chartID,
                        backgroundColor: "transparent",
                    },
                    title: {
                        text: '',
                        align: 'left',
                        enabled: false
                    },
                    legend: {
                        align: "left",
                        verticalAlign: "top",
                        enabled: false
                    },
                    xAxis: {
                        categories: this.areaChartCategories,
                        gridLineDashStyle: "solid",
                        gridLineColor: "#BAC6Df",
                        gridLineWidth: 0,
                        lineWidth: 1,
                        lineColor: "#29264C"
                    },
                    yAxis: {
                        gridLineDashStyle: "LongDash",
                        gridLineColor: "#BAC6Df",
                        gridLineWidth: 1,
                        lineWidth: 0,
                        title: {
                            enabled: false
                        },
                        labels: {
                            formatter: function (){
                                return this.value + " " + self.indicatorUnit
                            }
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    tooltip:{
                        useHTML: true,
                        shared: true,
                        formatter: function (){
                            var htmlTooltip = "<div class='tooltip_wrapper'>";
                            htmlTooltip += "<div class='tooltip_title'>"+this.x+"</div>";
                            _.each(this.points, function (pointObj){
                                var formattedValue = UTILS.formatNumber(pointObj.y, 2, self.indicatorUnit);
                                htmlTooltip += "<div class='tooltip_value'><div class='value_label'>"+pointObj.series.name+"</div><div class='value_figure'><div class='figure_bar' style='background-color:"+pointObj.color+"'></div>" + formattedValue + "" +self.indicatorUnit+"</div></div>";
                            });
                            htmlTooltip += "</div>";
                            return htmlTooltip;
                            /*
                            htmlTooltip += "<div class='tooltip_value'><div class='value_label'>"+self.indicatorLabel+"</div><div class='value_figure'><div class='figure_bar' style='background-color:"+this.color+"'></div>" + numberFormat(this.y, 0, '', ' ') + " "+self.indicatorUnit+"</div></div>";
                            htmlTooltip += "</div>";
                            return htmlTooltip;
                            */
                        }
                    },
                    plotOptions: {
                        area: {
                            fillOpacity: 1,
                            stacking: 'normal',
                            lineWidth: 2,
                            lineColor: "#fff",
                            marker: {
                                enabled: false,
                                symbol: "circle",
                            }
                        }
                    },
                    series: this.areaChartData
                });

                this.loaderDisplayed = false;
            },
        },
        watch: {
            areaChartData: function () {
                if(this.areaChartData[0] !== undefined) {
                    this.renderAreaChart();
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    .areachart_wrapper{
        width: 100%;
        height: 100%;
        position: relative;
        text-align: center;

        .highcharts-container{
            width: 100% !important;
            height: 100% !important;
        }

        .area_legend_items{
            margin-top: 20px;
        }

        .areachart_container{
            margin-top: 30px;
            min-height: 400px;
        }
    }
</style>



// WEBPACK FOOTER //
// components/highchartsAreaChart.vue